import api from '../api';

// MIGRATION: Independent agents now use the unified /payments endpoints.
// Field names (first_name, last_name, amount, payment_type, payment_method,
// status) match directly. The one difference: the unified table doesn't
// have a transaction_date column, only created_at, so it's aliased here for
// the existing Independent payments list UI.
const fromUnifiedPayment = (payment) => {
  if (!payment || typeof payment !== 'object') return payment;
  return {
    ...payment,
    transaction_date: payment.transaction_date || payment.created_at
  };
};

export const independentPaymentsService = {
  getAll: async () => {
    const response = await api.get('/payments');
    return Array.isArray(response.data) ? response.data.map(fromUnifiedPayment) : response.data;
  }
};

export default independentPaymentsService;
